import {_} from 'lodash';
import {nsMapping} from "./fn";
import {lm} from "../../../appContext";
import tpl_tableHtml from './tpl_table.html?raw';
import tpl_rowHtml from './tpl_row.html?raw';

const tpl_table: string = tpl_tableHtml
const tpl_row: string = tpl_rowHtml;

export default class Transform {
    mappings: ITransformMapping[];
    subject: string;

    constructor(expression: string) {
        const data = nsMapping.parseExpression(expression);
        this.subject = data.subject;
        this.mappings = data.mappings;
    }

    getOutput(): string {
        const mappingsSorted = _.sortBy(this.mappings, (m: ITransformMapping) => m.source.toLowerCase());
        const tplRows = mappingsSorted.map((mapping: ITransformMapping): string => {
            return tpl_row.replace("{{SOURCE}}", mapping.source).replace("{{DESTINATION}}", mapping.destination);
        }).join("\n");
        const tpl = tpl_table
            .replace("{{SUBJECT}}", this.subject)
            .replace("{{ROWS}}", tplRows)
            .replace('{{SOURCE_HEADING}}', lm.t('source') ?? '')
            .replace('{{TARGET_HEADING}}', lm.t('target') ?? '')
        return tpl;
    }

}
